import React, { Component, Fragment } from 'react';
import ReactDOM from "react-dom";
import 'rapidoc'; // <-- import rapidoc

export class MyApiDoc extends Component {
  render() {
    return <Fragment>
    <rapi-doc
      spec-url = "/static/openapi.yaml"
      render-style = "view"
      allow-spec-url-load = {"false"}
      allow-spec-file-load = {"false"}
      style = {{ height: "100vh", width: "100%" }}>
    </rapi-doc>
    </Fragment>
    }

  }

ReactDOM.render(<MyApiDoc />, document.querySelector("#app")); 